import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateField } from "../../contexts/Utils";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Resize,
} from "@syncfusion/ej2-react-grids";
import {
  GetAllEmployees,
  getAssemblybySo,
  getLastBoxId,
  PrintBoxQrCodeApi,
  ShipAssemblyApi,
} from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import { useStateContext } from "../../contexts/ContextProvider";
import TextAreaField from "../../components/TextAreaField";
import TextInputField from "../../components/TextInputField";
import SelectField from "../../components/SelectField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";
import DateTimeField from "../../components/DateTimeField";
import DoubleField from "../../components/DoubleField";

const ShipAssembly = () => {
  const navigate = useNavigate();
  let param = useParams();
  const so_id = param.so_id;
  const gpuRef = useRef(null);
  const gridRef = useRef(null);
  const { userID } = useStateContext();
  const [getEmployees, setEmployees] = useState([]);
  const [Sns, setSns] = useState([]);
  const [formData, setFormData] = useState({
    part: "Select Part",
    sn: "",
    sku: "",
    box_id: "",
    box_qrcode: "",
    lot_no: "",
    qty: 0,
    employee: "Select Employee",
    remarks: "",
    other: "",
    note: "",
  });
  const [oDatetime, setODatetime] = useState("");
  const [errors, setErrors] = useState({});
  const [loadBtn, setLoadBtn] = useState(false);

  const snsGrid = [
    {
      type: "CheckBox",
      width: "50",
    },
    {
      field: "gpu_sn",
      headerText: "GPU SN",
      minWidth: "80",
      width: "140",
      textAlign: "left",
    },
    {
      field: "wb_sn",
      headerText: "Block SN",
      minWidth: "80",
      width: "170",
      textAlign: "left",
    },
    {
      field: "test_result",
      headerText: "Test Res",
      minWidth: "40",
      width: "100",
      textAlign: "left",
    },
    {
      field: "test_scan_date",
      headerText: "Test Date",
      type: "datetime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "40",
      width: "125",
      textAlign: "center",
    },
    {
      field: "install_date",
      headerText: "Assm Date",
      type: "datetime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "40",
      width: "125",
      textAlign: "center",
    },
  ];

  const handleRowSelected = (args) => {
    const indexx = gridRef?.current?.getSelectedRowIndexes() || [];
    setFormData((prev) => ({ ...prev, qty: indexx.length }));
  };

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/GpuWb");
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    if (name === "sn") {
      if (value.length > 10 && value.length < 18) {
        const grid = gridRef?.current;
        const selected = grid?.getSelectedRowIndexes();
        const index = Sns.findIndex((item) => item.gpu_sn === value);
        if (index >= 0) {
          if (selected.includes(index)) grid.selectRows(selected);
          else grid.selectRows([...selected, index]);
        }
        setFormData((prev) => ({ ...prev, [name]: value }));
        gpuRef?.current?.focus();
      } else setFormData((prev) => ({ ...prev, [name]: value, gpu_id: 0 }));
    } else setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = (option, e) => {
    if (option && option.value) {
      setFormData((prev) => ({ ...prev, [e.name]: option }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    try {
      const indexes = gridRef?.current?.getSelectedRowIndexes();
      if (indexes.length <= 0) {
        showErrorToast("Error!", "Select one or more assembly to ship!");
        setLoadBtn(false);
        gpuRef?.current?.focus();
        return;
      }
      const now = new Date(oDatetime);
      const now1 = new Date(oDatetime);
      now1.setMinutes(now1.getMinutes() - now1.getTimezoneOffset());
      const assys = indexes.map((i) => Sns[i]);
      const ress = await getLastBoxId(now1.toISOString().slice(0, 19));
      let boxId = "A0";
      if (ress.data) {
        const boxx = ress.data.slice(-2);
        let prefix = boxx.match(/[a-zA-Z]+/)[0]; // Extracts "a"
        let num = parseInt(boxx.match(/\d+/)[0], 10); // Extracts 0
        boxId = prefix + (num + 1);
      }
      const newCode =
        "XW" +
        so_id.slice(-5) +
        now.getFullYear().toString().slice(-2) +
        ("0" + (now.getMonth() + 1)).slice(-2) +
        ("0" + now.getDate()).slice(-2) +
        boxId;
      const rec = assys[0];
      let sns = "";
      assys.forEach((item, i) => {
        sns += item.gpu_sn + ">" + item.wb_sn;
        if (i < assys.length - 1) sns += "|";
      });
      const newQr = rec.sku + "|" + newCode + "|" + sns;
      const assy_ids = assys.map((item) => item.assembly_id);
      const reqData = {
        assembly_ids: assy_ids,
        employee_id: formData.employee.value,
        user_id: userID,
        ship_date: oDatetime,
        box_qrcode: newQr,
        box_id: newCode,
        assembler: formData.employee.label,
        lot_no: newCode.slice(-8),
        remarks: formData.remarks,
        other: formData.other,
        notes: formData.note,
      };
      const response = await ShipAssemblyApi(reqData);
      if (response.success) {
        if (window.confirm(`Do you want to print the Box QR Code now?`)) {
          const resp = await PrintBoxQrCodeApi(so_id, newCode);
          if (!resp) showErrorToast("Error!", "Record not found!");
        }
        showSuccessToast("Success!", "Assemblies shipped successfully!");
        navigate("/GpuWb");
      } else
        showErrorToast("Error!", "Assy failed to ship!\n\n" + response.message);
    } catch (err) {
      showErrorToast("Error!", "Assemblies did not ship!");
    } finally {
      setLoadBtn(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (so_id) {
        TimeoutUtility.resetTimeout();
        var now = new Date();
        var now1 = new Date();
        now1.setMinutes(now1.getMinutes() - now1.getTimezoneOffset());
        setODatetime(now1.toISOString().slice(0, 19));
        await GetAllEmployees()
          .then((resp) => {
            const employeeOptions = resp.data.map((item) => ({
              label: item.name,
              value: item.employee_id,
            }));
            setEmployees(employeeOptions || []);
          })
          .catch((err) => console.log(err.message));
        await getAssemblybySo(so_id)
          .then(async (resp) => {
            const assys = resp.data.filter((item) => item.ship_date === null);
            if (assys.length === 0) return;
            setSns(assys || []);
            const ress = await getLastBoxId(now1.toISOString().slice(0, 19));
            let boxId = "A0";
            if (ress.data) {
              const boxx = ress.data.slice(-2);
              let prefix = boxx.match(/[a-zA-Z]+/)[0]; // Extracts "a"
              let num = parseInt(boxx.match(/\d+/)[0], 10); // Extracts 0
              boxId = prefix + (num + 1);
            }
            const newCode =
              "XW" +
              so_id.slice(-5) +
              now.getFullYear().toString().slice(-2) +
              ("0" + (now.getMonth() + 1)).slice(-2) +
              ("0" + now.getDate()).slice(-2) +
              boxId;
            const rec = assys[0];
            let sns = "";
            assys.forEach((item, i) => {
              sns += item.gpu_sn + ">" + item.wb_sn;
              if (i < assys.length - 1) sns += "|";
            });
            const newQr = rec.sku + "|" + newCode + "|" + sns;
            setFormData((prev) => ({
              ...prev,
              sku: rec.sku,
              part: rec.part_number + " - " + rec.part_description,
              lot_no: newCode.slice(-8),
              box_id: newCode,
              box_qrcode: newQr,
            }));
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [so_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="SHIP GPUs" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col xl={6} lg={6} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="SO:"
                  name="so_id"
                  value={so_id}
                  placeholder="Name"
                  disabled
                />
                <TextInputField
                  label="Order Part:"
                  name="part"
                  value={formData.part}
                  placeholder="Part"
                  disabled
                />
                <TextInputField
                  label="SKU:"
                  name="sku"
                  value={formData.sku}
                  placeholder="SKU"
                  disabled
                />
                <TextInputField
                  label="Lot # [Auto]:"
                  name="lot_no"
                  value={formData.lot_no}
                  placeholder="Lot #"
                  disabled
                />
                <TextInputField
                  label="Box ID [Auto]:"
                  name="box_id"
                  value={formData.box_id}
                  placeholder="Box ID"
                  disabled
                />
                <TextAreaField
                  label="Box QR Code [Auto]:"
                  name="box_qrcode"
                  value={formData.box_qrcode}
                  placeholder="Box QR Code"
                  disabled
                />
                <TextInputField
                  label="Remarks:"
                  name="remarks"
                  value={formData.remarks}
                  onChange={handleChange}
                  placeholder="Remarks"
                  error={errors.remarks}
                  disabled={formData.qty === 0}
                />
                <TextInputField
                  label="Other:"
                  name="other"
                  value={formData.other}
                  onChange={handleChange}
                  placeholder="Other"
                  error={errors.other}
                  disabled={formData.qty === 0}
                />
                <TextAreaField
                  label="Note:"
                  name="note"
                  value={formData.note}
                  onChange={handleChange}
                  placeholder="Note"
                  error={errors.note}
                  disabled={formData.qty === 0}
                />
              </div>
            </Col>
            <Col xl={6} lg={6} className="container-col">
              <DoubleField
                label="Ship Quantity:"
                name="qty"
                value={formData.qty}
                placeholder="Ship Quantity"
                disabled
              />
              <DateTimeField
                label="Ship Datetime:"
                name="ship_date"
                value={oDatetime}
                placeholder="DateTime"
                now={false}
                formField={true}
                disabled
              />
              <SelectField
                label="Ship Operator:"
                name="employee"
                value={formData.employee}
                options={getEmployees}
                onChange={handleSelectChange}
                placeholder="Operator"
                compulsory={true}
                error={errors.employee}
                isDisabled={formData.qty === 0}
              />
              <TextInputField
                ref={gpuRef}
                label="GPU SN Scan:"
                name="sn"
                value={formData.sn}
                onChange={handleChange}
                placeholder="GPU SN"
                compulsory={true}
              />
              <GridComponent
                ref={gridRef}
                className="custom-grid1 pt-8"
                dataSource={Sns}
                height="calc(50vh - 180px)"
                allowResizing
                //  allowSorting
                //  recordDoubleClick={handleRowDoubled}
                rowHeight={24}
                rowDeselected={handleRowSelected}
                rowSelected={handleRowSelected}
              >
                <ColumnsDirective>
                  {snsGrid.map((item, index) => (
                    <ColumnDirective key={index} {...item} />
                  ))}
                </ColumnsDirective>
                <Inject services={[Resize]} />
              </GridComponent>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-8">
        <Button
          margin="10px"
          padding="20px"
          text="Ship Batch"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Close"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default ShipAssembly;
